import React from 'react';
import styled from 'styled-components';
import ControlPlaneLayout from '../controlplane/ControlPlaneLayout';

const Grid = styled.section`
  display: grid;
  gap: 1rem;

  @media (min-width: 900px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

const Card = styled.article`
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 20px;
  padding: 1.25rem;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);
`;

const CardTitle = styled.h2`
  margin: 0 0 0.65rem;
  font-size: 1rem;
`;

const CardBody = styled.p`
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #475569;
`;

const RequestsPage = () => {
  return (
    <ControlPlaneLayout
      eyebrow="Requests Control Plane"
      title="Requests Control Plane"
      description="Create and review request markets, manage approval-required drafts, and monitor settlement activity as the app shifts from the legacy dashboard toward a requests-first operating surface."
    >
      <Grid>
        <Card>
          <CardTitle>Drafts and Approvals</CardTitle>
          <CardBody>
            Review agent-originated drafts, check resolution anchors, and approve requests that
            cross spend or visibility thresholds.
          </CardBody>
        </Card>
        <Card>
          <CardTitle>Open Requests</CardTitle>
          <CardBody>
            Track active request markets, provider submissions, and the current state of each
            structured question.
          </CardBody>
        </Card>
        <Card>
          <CardTitle>Settlement Activity</CardTitle>
          <CardBody>
            Inspect reserve remaining, early releases, and final outcome-linked payout activity in
            one place.
          </CardBody>
        </Card>
      </Grid>
    </ControlPlaneLayout>
  );
};

export default RequestsPage;
